export enum ChaletNameEnum {
    LaChouette = "LaChouette",
    PetitePia = "PetitePia",
    Caro = "Caro",
    LesLoups = "LesLoups",
    Yeti = "Yeti",
    Galta = "Galta",
    Alya = "Alya",
    LesSolans = "LesSolans",
}

export interface Availability {
    Id: number;
    name: ChaletNameEnum;
    arrivalDate: Date
    departureDate: Date
    duration: number
    minPax: number
    maxPax: number
    schoolHoliday: string
    originalPrice: number
    currentPrice: number
    discount: number
    notes: string

    productEnhancements: string

    isFullyBooked: boolean

    roomsBooked: boolean[],
    isPricePerPerson: boolean,
}